import React, { useEffect, useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import OrderType from "./index";
import { CartContext, LocationsContext } from "../../context";
import _ from "lodash";
import ScheduleTime from "../ScheduleTime";
import { useTrans } from "../../hooks";

const OrderTypeModal = () => {
  // get the translation function
  const transMsg = useTrans();
  // get the order type and the cart line items from the cart context
  const { orderType, cartLineItems } = useContext(CartContext);
  // create a state to show or hide the modal
  const [show, setShow] = useState(false);

  // get the selected location from the locations context
  const { selectedLocation } = useContext(LocationsContext);

  // ================================================================
  // This effect will run when the orderType, selectedLocation, or cartLineItems are changed
  useEffect(() => {
    // if the user has not selected a location, we don't need to ask him about delivery or pickup
    if (_.isEmpty(selectedLocation)) return;
    // if the cart is empty, we don't need to ask him about delivery or pickup
    if (_.isUndefined(cartLineItems)) return;
    if (_.isEmpty(cartLineItems)) return;

    // if the user has already selected between delivery or pickup, we don't need to ask him again
    if (!_.isEmpty(orderType)) return;

    // we will ask the user about delivery or pickup
    console.log("We will ask the user about delivery or pickup by showing him the modal");
    setShow(true);
  }, [orderType, selectedLocation, cartLineItems]);

  // ================================================================
  return (
    <>
      {!_.isEmpty(selectedLocation) && (
        <>
          <Modal
            show={show}
            backdrop="static"
            onHide={() => {
              setShow(false);
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title> {transMsg("deliveryOrPickup")} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>{transMsg("OrderTypeModalContent1")} :</h6>
              <div className="row">
                <div className="col-12 ">
                  <OrderType label={transMsg("method") + ":"} showModal />
                </div>

                <div className="col-12">
                  <ScheduleTime label={transMsg("scheduleTime")} hoursType="auto" />
                </div>
              </div>
              <Button
                className="btn btn-warning btn-block py-3 text-dark text-center dropdown-item btn-checkout bold"
                style={{ width: "100%" }}
                onClick={() => {
                  setShow(false);
                }}
              >
                {transMsg("done")}
              </Button>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default OrderTypeModal;
